import { createSignal, createEffect, onMount, Signal, For } from 'solid-js';
import STAlert, { AlertType } from '../st-alert/st-alert';
import STRadioGroup from '../st-radio-group/st-radio-group';
import { Verbosity, VoiceAttitude, VoiceTone } from 'st-app/api';
import { useGridStore } from './st-grid-generator-btn';

export class MyWritingStyleModalProps {
    show!: Signal<boolean>
}

export function MyWritingStyleModal(props: MyWritingStyleModalProps) {
    const gridStore = useGridStore();
    const myStyle = gridStore.myWritingStyle();

    const tone = createSignal('0');
    const attitude = createSignal('0');
    const verbosity = createSignal('0');

    const verbosityEntries = Object.entries(Verbosity)
        .filter(e => Number(e[1]) >= 0);

    const [show, setShow] = props.show;
    let writingStyleConfigModal!: HTMLDialogElement;;

    onMount(() => {
        requestAnimationFrame(() => {
            createEffect(() => {
                if (show()) {
                    writingStyleConfigModal.showModal();
                }
                else {
                    writingStyleConfigModal.close();
                }
            });
        })
    });

    createEffect(() => {
        const myStyle = gridStore.myWritingStyle();

        tone[1](myStyle.tone.toString());
        attitude[1](myStyle.attitude.toString());
        verbosity[1](myStyle.verbosity.toString());
    });

    return <dialog ref={writingStyleConfigModal} onClick={tryClose} use:draggable={undefined} style="min-width: 600px">
        <STAlert type="info">Define Your Writing Style</STAlert>
        <h3>Tone:</h3>
        <STRadioGroup name="tone" value={tone}>
            <STRadioGroup.Option icon="Images/ST_VIEW/WritingStyle/Casual.svg" label="Casual" value="0"></STRadioGroup.Option>
            <STRadioGroup.Option icon="Images/ST_VIEW/WritingStyle/Technical.svg" label="Technical" value="1"></STRadioGroup.Option>
            <STRadioGroup.Option icon="Images/ST_VIEW/WritingStyle/Formal.svg" label="Formal" value="2"></STRadioGroup.Option>
        </STRadioGroup>
        <h3>Attitude:</h3>
        <STRadioGroup name="attitude" value={attitude}>
            <STRadioGroup.Option icon="Images/ST_VIEW/WritingStyle/Neutral.svg" label="Neutral" value="0"></STRadioGroup.Option>
            <STRadioGroup.Option icon="Images/ST_VIEW/WritingStyle/Empathetic.svg" label="Empathetic" value="1"></STRadioGroup.Option>
            <STRadioGroup.Option icon="Images/ST_VIEW/WritingStyle/Enthusiastic.svg" label="Enthusiastic" value="2"></STRadioGroup.Option>
            <STRadioGroup.Option icon="Images/ST_VIEW/WritingStyle/Persuasive.svg" label="Persuasive" value="3"></STRadioGroup.Option>
        </STRadioGroup>
        <h3>Verbosity:</h3>
        <STRadioGroup name="verbosity" value={verbosity}>
            <For each={verbosityEntries}>{(v) => (
                <STRadioGroup.Option icon={`Images/ST_VIEW/WritingStyle/${v[0]}.svg`} label={v[0]} value={v[1].toString()} ></STRadioGroup.Option>
            )}</For>
        </STRadioGroup>
    </dialog>;

    function tryClose(this: HTMLDialogElement, ev: MouseEvent) {
        const rect = this.getBoundingClientRect();
        const isInDialog = (rect.top <= ev.clientY && ev.clientY <= rect.top + rect.height &&
            rect.left <= ev.clientX && ev.clientX <= rect.left + rect.width);

        if (ev.target === this && !isInDialog) {
            gridStore.setMyWritingStyle({
                writingStyleGU: gridStore.myWritingStyle().writingStyleGU,
                tone: VoiceTone[VoiceTone[+tone[0]()] as keyof typeof VoiceTone],
                attitude: VoiceAttitude[VoiceAttitude[+attitude[0]()] as keyof typeof VoiceAttitude],
                verbosity: Verbosity[Verbosity[+verbosity[0]()] as keyof typeof Verbosity],
            });
            setShow(false);
        }
    }
}
